import { useEffect } from "react";
import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

// Define the option type for select fields
export interface OptionType {
  label: string;
  value: string;
}

// Create a type for fields that may have async options
export type AsyncSelectField = ModuleFields & {
  loadOptions?: () => Promise<OptionType[]>;
};

// Function to fetch data and transform to options
export const FetchSubModule = async (value?:string): Promise<OptionType[]>  => {
  if (value) {
    // if(value === 'ANNOUNCEMENT'){
    //   return [
    //     {
    //       label: "General",
    //       value: "general",
    //     },
    //     {
    //       label: "Tender",
    //       value: "tender",
    //     },
    //     {
    //       label: "Circular",
    //       value: "circular",
    //     },
    //   ];
    // } else if(value === 'Manual'){ 
    //   return [
    //   //   {
    //   //   label: "Manual Welcome Page",
    //   //   value: "manualWelcomePage",
    //   // },
    //   {
    //     label: "Introduction/Preface",
    //     // value: "introduction_preface",
    //     value: "Introduction/Preface",
    //   },
    //   {
    //     label: "Introduction/Procurement Codes Of Ethics",
    //     // value: "introduction_procurementCodesOfEthics",
    //     value: "Introduction/Procurement Codes Of Ethics",
    //   },
    //   {
    //     label: "Introduction/General Provision",
    //     // value: "introduction_generalProvision",
    //     value: "Introduction/General Provision",
    //   },
    //   {
    //     label: "Introduction/Terms & Conditions",
    //     // value: "introduction_termsAndConditions",
    //     value: "Introduction/Terms & Conditions",
    //   },
    //   {
    //     label: "Introduction/Process Symbols",
    //     // value: "introduction_processSymbols",
    //     value: "Introduction/Process Symbols",
    //   },
    //   {
    //     label: "Introduction/MAHB Procurement Value Chain",
    //     // value: "introduction_mahbProcurementValueChain",
    //     value: "Introduction/MAHB Procurement Value Chain",
    //   },
    //   {
    //     label: "Procurement Planning/Business Case/Overview",
    //     value: "Procurement Planning/Business Case/Overview",
    //     // value: "procurementPlanning_businessCase_businessCaseOverview",
    //   },
    //   {
    //     label: "Procurement Planning/Business Case/Policies",
    //     value: "Procurement Planning/Business Case/Policies",
    //     // value: "procurementPlanning_businessCase_businessCasePolicies",
    //   },
    //   {
    //     label: "Procurement Planning/Business Case/Process Flow Chart",
    //     value: "Procurement Planning/Business Case/Process Flow Chart",
    //     // value: "procurementPlanning_businessCase_businessCaseProcessFlowChart",
    //   },
    //   {
    //     label: "Procurement Planning/Business Case/Process Flow Chart/List Process Flow Chart",
    //     value: "Procurement Planning/Business Case/Process Flow Chart/List Process Flow Chart",
    //     // value: "procurementPlanning_businessCase_businessCaseProcessFlowChart_procurementPlanningProcessFlowChart",
    //   },
    //   {
    //     label: "Procurement Planning/Annual Procurement Planning/Overview",
    //     value: "Procurement Planning/Annual Procurement Planning/Overview",
    //     // value: "procurementPlanning_annualProcurementPlanning_annualProcurementPlanningOverview",
    //   },
    //   {
    //     label: "Procurement Planning/Annual Procurement Planning/Policies",
    //     value: "Procurement Planning/Annual Procurement Planning/Policies",
    //     // value: "procurementPlanning_annualProcurementPlanning_annualProcurementPlanningPolicies",
    //   },
    //   {
    //     label: "Procurement Planning/Annual Procurement Planning/Process Flow Chart",
    //     value: "Procurement Planning/Annual Procurement Planning/Process Flow Chart",
    //     // value: "procurementPlanning_annualProcurementPlanning_annualProcurementPlanningProcessFlowChart",
    //   },
    //   {
    //     label: "Procurement Planning/Annual Procurement Planning/Process Flow Chart/List Process Flow Chart",
    //     value: "Procurement Planning/Annual Procurement Planning/Process Flow Chart/List Process Flow Chart",
    //     // value: "procurementPlanning_annualProcurementPlanning_annualProcurementPlanningProcessFlowChart_procurementPlanningProcessFlowChart",
    //   },
    //   {
    //     label: "Procurement Planning/Strategy Paper/Overview",
    //     value: "Procurement Planning/Strategy Paper/Overview",
    //     // value: "procurementPlanning_strategyPaper_strategyPaperOverview",
    //   },
    //   {
    //     label: "Procurement Planning/Strategy Paper/Policies",
    //     value: "Procurement Planning/Strategy Paper/Policies",
    //     // value: "procurementPlanning_strategyPaper_strategyPaperPolicies",
    //   },
    //   {
    //     label: "Procurement Planning/Strategy Paper/Process Flow Chart",
    //     value: "Procurement Planning/Strategy Paper/Process Flow Chart",
    //     // value: "procurementPlanning_strategyPaper_strategyPaperProcessFlowChart",
    //   },
    //   {
    //     label: "Procurement Planning/Strategy Paper/Process Flow Chart/List Process Flow Chart",
    //     value: "Procurement Planning/Strategy Paper/Process Flow Chart/List Process Flow Chart",
    //     // value: "procurementPlanning_strategyPaper_strategyPaperProcessFlowChart_procurementPlanningProcessFlowChart",
    //   },
    //   {
    //     label: "Requisition/Purchase Requisition/Overview",
    //     value: "Requisition/Purchase Requisition/Overview",
    //     // value: "requisition_purchaseRequisition_purchaseRequisitionOverview",
    //   },
    //   {
    //     label: "Requisition/Purchase Requisition/Policies",
    //     value: "Requisition/Purchase Requisition/Policies",
    //     // value: "requisition_purchaseRequisition_purchaseRequisitionPolicies",
    //   },
    //   {
    //     label: "Requisition/Purchase Requisition/Process Flow Chart",
    //     value: "Requisition/Purchase Requisition/Process Flow Chart",
    //     // value: "requisition_purchaseRequisition_purchaseRequisitionProcessFlowChart",
    //   },
    //   {
    //     label: "Requisition/Purchase Requisition/Process Flow Chart/List Process Flow Chart",
    //     value: "Requisition/Purchase Requisition/Process Flow Chart/List Process Flow Chart",
    //     // value: "requisition_purchaseRequisition_purchaseRequisitionProcessFlowChart_requisitionProcessFlowChart",
    //   },
    //   {
    //     label: "Requisition/Processing of Purchase Requisition/Overview",
    //     value: "Requisition/Processing of Purchase Requisition/Overview",
    //     // value: "requisition_processingofPurchaseRequisition_processingofPurchaseRequisitionOverview",
    //   },
    //   {
    //     label: "Requisition/Processing of Purchase Requisition/Policies",
    //     value: "Requisition/Processing of Purchase Requisition/Policies",
    //     // value: "requisition_processingofPurchaseRequisition_processingofPurchaseRequisitionPolicies",
    //   },
    //   {
    //     label: "Requisition/Processing of Purchase Requisition/Process Flow Chart",
    //     value: "Requisition/Processing of Purchase Requisition/Process Flow Chart",
    //     // value: "requisition_processingofPurchaseRequisition_processingofPurchaseRequisitionProcessFlowChart",
    //   },
    //   {
    //     label: "Requisition/Processing of Purchase Requisition/Process Flow Chart/List Process Flow Chart",
    //     value: "Requisition/Processing of Purchase Requisition/Process Flow Chart/List Process Flow Chart",
    //     // value: "requisition_processingofPurchaseRequisition_processingofPurchaseRequisitionProcessFlowChart_requisitionProcessFlowChart",
    //   },
    //   {
    //     label: "Sourcing/Tender Management/Overview",
    //     value: "Sourcing/Tender Management/Overview",
    //     // value: "sourcing_tenderManagement_tenderManagementOverview",
    //   },
    //   {
    //     label: "Sourcing/Tender Management/Policies",
    //     value: "Sourcing/Tender Management/Policies",
    //     // value: "sourcing_tenderManagement_tenderManagementPolicies",
    //   },
    //   {
    //     label: "Sourcing/Tender Management/Process Flow Chart",
    //     value: "Sourcing/Tender Management/Process Flow Chart",
    //     // value: "sourcing_tenderManagement_tenderManagementProcessFlowChart",
    //   },
    //   {
    //     label: "Sourcing/Tender Management/Process Flow Chart/List Process Flow Chart",
    //     value: "Sourcing/Tender Management/Process Flow Chart/List Process Flow Chart",
    //     // value: "sourcing_tenderManagement_tenderManagementProcessFlowChart_sourcingProcessFlowChart",
    //   },
    //   {
    //     label: "Sourcing/Tender Administration/Overview",
    //     value: "Sourcing/Tender Administration/Overview",
    //     // value: "sourcing_tenderAdministration_tenderAdministrationOverview",
    //   },
    //   {
    //     label: "Sourcing/Tender Administration/Policies",
    //     value: "Sourcing/Tender Administration/Policies",
    //     // value: "sourcing_tenderAdministration_tenderAdministrationPolicies",
    //   },
    //   {
    //     label: "Sourcing/Tender Administration/Process Flow Chart - above RM50,000.00",
    //     value: "Sourcing/Tender Administration/Process Flow Chart - above RM50,000.00",
    //     // value: "sourcing_tenderAdministration_tenderAdministrationProcessFlowChartaboveRM5000000",
    //   },
    //   {
    //     label: "Sourcing/Tender Administration/Process Flow Chart - above RM50,000.00/List Process Flow Chart",
    //     value: "Sourcing/Tender Administration/Process Flow Chart - above RM50,000.00/List Process Flow Chart",
    //     // value: "sourcing_tenderAdministration_tenderAdministrationProcessFlowChartaboveRM5000000_sourcingProcessFlowChart",
    //   },
    //   {
    //     label: "Sourcing/Tender Administration/Process Flow Chart - below RM50,000.00",
    //     value: "Sourcing/Tender Administration/Process Flow Chart - below RM50,000.00",
    //     // value: "sourcing_tenderAdministration_tenderAdministrationProcessFlowChartbelowRM5000000",
    //   },
    //   {
    //     label: "Sourcing/Tender Administration/Process Flow Chart - below RM50,000.00/List Process Flow Chart",
    //     value: "Sourcing/Tender Administration/Process Flow Chart - below RM50,000.00/List Process Flow Chart",
    //     // value: "sourcing_tenderAdministration_tenderAdministrationProcessFlowChartbelowRM5000000_sourcingProcessFlowChart",
    //   },
    //   {
    //     label: "Sourcing/Tender Evaluation/Overview",
    //     value: "Sourcing/Tender Evaluation/Overview",
    //     // value: "sourcing_tenderEvaluation_tenderEvaluationOverview",
    //   },
    //   {
    //     label: "Sourcing/Tender Evaluation/Policies",
    //     value: "Sourcing/Tender Evaluation/Policies",
    //     // value: "sourcing_tenderEvaluation_tenderEvaluationPolicies",
    //   },
    //   {
    //     label: "Sourcing/Tender Evaluation/Process Flow Chart",
    //     value: "Sourcing/Tender Evaluation/Process Flow Chart",
    //     // value: "sourcing_tenderEvaluation_tenderEvaluationProcessFlowChart",
    //   },
    //   {
    //     label: "Sourcing/Tender Evaluation/Process Flow Chart/List Process Flow Chart",
    //     value: "Sourcing/Tender Evaluation/Process Flow Chart/List Process Flow Chart",
    //     // value: "sourcing_tenderEvaluation_tenderEvaluationProcessFlowChart_sourcingProcessFlowChart",
    //   },
    //   {
    //     label: "Sourcing/Abort of Tender/Overview",
    //     value: "Sourcing/Abort of Tender/Overview",
    //     // value: "sourcing_abortofTender_abortofTenderOverview",
    //   },
    //   {
    //     label: "Sourcing/Abort of Tender/Policies",
    //     value: "Sourcing/Abort of Tender/Policies",
    //     // value: "sourcing_abortofTender_abortofTenderPolicies",
    //   },
    //   {
    //     label: "Sourcing/Abort of Tender/Process Flow Chart",
    //     value: "Sourcing/Abort of Tender/Process Flow Chart",
    //     // value: "sourcing_abortofTender_abortofTenderProcessFlowChart",
    //   },
    //   {
    //     label: "Sourcing/Abort of Tender/Process Flow Chart/List Process Flow Chart",
    //     value: "Sourcing/Abort of Tender/Process Flow Chart/List Process Flow Chart",
    //     // value: "sourcing_abortofTender_abortofTenderProcessFlowChart_sourcingProcessFlowChart",
    //   },
    //   {
    //     label: "Sourcing/Clarification / Negotiation prior to Award/Overview",
    //     value: "Sourcing/Clarification / Negotiation prior to Award/Overview",
    //     // value: "sourcing_clarificationNegotiationpriortoAward_clarificationNegotiationpriortoAwardOverview",
    //   },
    //   {
    //     label: "Sourcing/Clarification / Negotiation prior to Award/Policies",
    //     value: "Sourcing/Clarification / Negotiation prior to Award/Policies",
    //     // value: "sourcing_clarificationNegotiationpriortoAward_clarificationNegotiationpriortoAwardPolicies",
    //   },
    //   {
    //     label: "Sourcing/Clarification / Negotiation prior to Award/Process Flow Chart Negotiation",
    //     value: "Sourcing/Clarification / Negotiation prior to Award/Process Flow Chart Negotiation",
    //     // value: "sourcing_clarificationNegotiationpriortoAward_clarificationNegotiationpriortoAwardProcessFlowChartNegotiation",
    //   },
    //   {
    //     label: "Sourcing/Clarification / Negotiation prior to Award/Process Flow Chart Negotiation/List Process Flow Chart",
    //     value: "Sourcing/Clarification / Negotiation prior to Award/Process Flow Chart Negotiation/List Process Flow Chart",
    //     // value: "sourcing_clarificationNegotiationpriortoAward_clarificationNegotiationpriortoAwardProcessFlowChartNegotiation_sourcingProcessFlowChart",
    //   },
    //   {
    //     label: "Sourcing/Clarification / Negotiation prior to Award/Process Flow Chart Clarification Prior to Award",
    //     value: "Sourcing/Clarification / Negotiation prior to Award/Process Flow Chart Clarification Prior to Award",
    //     // value: "sourcing_clarificationNegotiationpriortoAward_clarificationNegotiationpriortoAwardProcessFlowChartClarificationPriortoAward",
    //   },
    //   {
    //     label: "Sourcing/Clarification / Negotiation prior to Award/Process Flow Chart Clarification Prior to Award/List Process Flow Chart",
    //     value: "Sourcing/Clarification / Negotiation prior to Award/Process Flow Chart Clarification Prior to Award/List Process Flow Chart",
    //     // value: "sourcing_clarificationNegotiationpriortoAward_clarificationNegotiationpriortoAwardProcessFlowChartClarificationPriortoAward_sourcingProcessFlowChart",
    //   },
    //   {
    //     label: "Contract Administration/Contract Management Implementation/Overview",
    //     value: "Contract Administration/Contract Management Implementation/Overview",
    //     // value: "contractAdministration_contractManagementImplementation_contractManagementImplementationOverview",
    //   },
    //   {
    //     label: "Contract Administration/Contract Management Implementation/Policies",
    //     value: "Contract Administration/Contract Management Implementation/Policies",
    //     // value: "contractAdministration_contractManagementImplementation_contractManagementImplementationPolicies",
    //   },
    //   {
    //     label: "Contract Administration/Contract Management Implementation/Process Flow Chart",
    //     value: "Contract Administration/Contract Management Implementation/Process Flow Chart",
    //     // value: "contractAdministration_contractManagementImplementation_contractManagementImplementationProcessFlowChart",
    //   },
    //   {
    //     label: "Contract Administration/Contract Management Implementation/Process Flow Chart/List Process Flow Chart",
    //     value: "Contract Administration/Contract Management Implementation/Process Flow Chart/List Process Flow Chart",
    //     // value: "contractAdministration_contractManagementImplementation_contractManagementImplementationProcessFlowChart_contractAdministrationProcessFlowChart",
    //   },
    //   {
    //     label: "Contract Administration/Contract Renewal/Overview",
    //     value: "Contract Administration/Contract Renewal/Overview",
    //     // value: "contractAdministration_contractRenewal_contractRenewalOverview",
    //   },
    //   {
    //     label: "Contract Administration/Contract Renewal/Policies",
    //     value: "Contract Administration/Contract Renewal/Policies",
    //     // value: "contractAdministration_contractRenewal_contractRenewalPolicies",
    //   },
    //   {
    //     label: "Contract Administration/Contract Renewal/Process Flow Chart",        
    //     value: "Contract Administration/Contract Renewal/Process Flow Chart",
    //     // value: "contractAdministration_contractRenewal_contractRenewalProcessFlowChart",
    //   },
    //   {
    //     label: "Contract Administration/Contract Renewal/Process Flow Chart/List Process Flow Chart",
    //     value: "Contract Administration/Contract Renewal/Process Flow Chart/List Process Flow Chart",
    //     // value: "contractAdministration_contractRenewal_contractRenewalProcessFlowChart_contractAdministrationProcessFlowChart",
    //   },
    //   {
    //     label: "Contract Administration/Contract Termination/Overview",
    //     value: "Contract Administration/Contract Termination/Overview",
    //     // value: "contractAdministration_contractTermination_contractTerminationOverview",
    //   },
    //   {
    //     label: "Contract Administration/Contract Termination/Policies",
    //     value: "Contract Administration/Contract Termination/Policies",
    //     // value: "contractAdministration_contractTermination_contractTerminationPolicies",
    //   },
    //   {
    //     label: "Contract Administration/Contract Termination/Process Flow Chart",
    //     value: "Contract Administration/Contract Termination/Process Flow Chart",
    //     // value: "contractAdministration_contractTermination_contractTerminationProcessFlowChart",
    //   },
    //   {
    //     label: "Contract Administration/Contract Termination/Process Flow Chart/List Process Flow Chart",
    //     value: "Contract Administration/Contract Termination/Process Flow Chart/List Process Flow Chart",
    //     // value: "contractAdministration_contractTermination_contractTerminationProcessFlowChart_contractAdministrationProcessFlowChart",
    //   },
    //   {
    //     label: "Contract Administration/Contract Closeout/Overview",
    //     value: "Contract Administration/Contract Closeout/Overview",
    //     // value: "contractAdministration_contractCloseout_contractCloseoutOverview",
    //   },
    //   {
    //     label: "Contract Administration/Contract Closeout/Policies",
    //     value: "Contract Administration/Contract Closeout/Policies",
    //     // value: "contractAdministration_contractCloseout_contractCloseoutPolicies",
    //   },
    //   {
    //     label: "Contract Administration/Contract Closeout/Process Flow Chart",
    //     value: "Contract Administration/Contract Closeout/Process Flow Chart",
    //     // value: "contractAdministration_contractCloseout_contractCloseoutProcessFlowChart",
    //   },
    //   {
    //     label: "Contract Administration/Contract Closeout/Process Flow Chart/List Process Flow Chart",
    //     value: "Contract Administration/Contract Closeout/Process Flow Chart/List Process Flow Chart",
    //     // value: "contractAdministration_contractCloseout_contractCloseoutProcessFlowChart_contractAdministrationProcessFlowChart",
    //   },
    //   {
    //     label: "Vendor Management/Vendor Registration/Overview",
    //     value: "Vendor Management/Vendor Registration/Overview",
    //     // value: "vendorManagement_vendorRegistration_vendorRegistrationOverview",
    //   },
    //   {
    //     label: "Vendor Management/Vendor Registration/Policies",
    //     value: "Vendor Management/Vendor Registration/Policies",
    //     // value: "vendorManagement_vendorRegistration_vendorRegistrationPolicies",
    //   },
    //   {
    //     label: "Vendor Management/Vendor Registration/Process Flow Chart - Renewal",
    //     value: "Vendor Management/Vendor Registration/Process Flow Chart - Renewal",
    //     // value: "vendorManagement_vendorRegistration_vendorRegistrationProcessFlowChartRenewal",
    //   },
    //   {
    //     label: "Vendor Management/Vendor Registration/Process Flow Chart - Renewal/List Process Flow Chart",
    //     value: "Vendor Management/Vendor Registration/Process Flow Chart - Renewal/List Process Flow Chart",
    //     // value: "vendorManagement_vendorRegistration_vendorRegistrationProcessFlowChartRenewal_vendorManagementProcessFlowChart",
    //   },
    //   {
    //     label: "Vendor Management/Vendor Registration/Process Flow Chart - New Registration",
    //     value: "Vendor Management/Vendor Registration/Process Flow Chart - New Registration",
    //     // value: "vendorManagement_vendorRegistration_vendorRegistrationProcessFlowChartNewRegistration",
    //   },
    //   {
    //     label: "Vendor Management/Vendor Registration/Process Flow Chart - New Registration/List Process Flow Chart",
    //     value: "Vendor Management/Vendor Registration/Process Flow Chart - New Registration/List Process Flow Chart",
    //     // value: "vendorManagement_vendorRegistration_vendorRegistrationProcessFlowChartNewRegistration_vendorManagementProcessFlowChart",
    //   },
    //   {
    //     label: "Vendor Management/Potential Vendor Screening/Overview",
    //     value: "Vendor Management/Potential Vendor Screening/Overview",
    //     // value: "vendorManagement_potentialVendorScreening_potentialVendorScreeningOverview",
    //   },
    //   {
    //     label: "Vendor Management/Potential Vendor Screening/Policies",
    //     value: "Vendor Management/Potential Vendor Screening/Policies",
    //     // value: "vendorManagement_potentialVendorScreening_potentialVendorScreeningPolicies",
    //   },
    //   {
    //     label: "Vendor Management/Potential Vendor Screening/Process Flow Chart",
    //     value: "Vendor Management/Potential Vendor Screening/Process Flow Chart",
    //     // value: "vendorManagement_potentialVendorScreening_potentialVendorScreeningProcessFlowChart",
    //   },
    //   {
    //     label: "Vendor Management/Potential Vendor Screening/Process Flow Chart/List Process Flow Chart",
    //     value: "Vendor Management/Potential Vendor Screening/Process Flow Chart/List Process Flow Chart",
    //     // value: "vendorManagement_potentialVendorScreening_potentialVendorScreeningProcessFlowChart_vendorManagementProcessFlowChart",
    //   },
    //   {
    //     label: "Vendor Management/Vendor Performance Management/Overview",
    //     value: "Vendor Management/Vendor Performance Management/Overview",
    //     // value: "vendorManagement_vendorPerformanceManagement_vendorPerformanceManagementOverview",
    //   },
    //   {
    //     label: "Vendor Management/Vendor Performance Management/Policies",
    //     value: "Vendor Management/Vendor Performance Management/Policies",
    //     // value: "vendorManagement_vendorPerformanceManagement_vendorPerformanceManagementPolicies",
    //   },
    //   {
    //     label: "Vendor Management/Vendor Performance Management/Process Flow Chart (Unscheduled)",
    //     value: "Vendor Management/Vendor Performance Management/Process Flow Chart (Unscheduled)",
    //     // value: "vendorManagement_vendorPerformanceManagement_vendorPerformanceManagementProcessFlowChartUnscheduled",
    //   },
    //   {
    //     label: "Vendor Management/Vendor Performance Management/Process Flow Chart (Unscheduled)/List Process Flow Chart",
    //     value: "Vendor Management/Vendor Performance Management/Process Flow Chart (Unscheduled)/List Process Flow Chart",
    //     // value: "vendorManagement_vendorPerformanceManagement_vendorPerformanceManagementProcessFlowChartUnscheduled_vendorManagementProcessFlowChart",
    //   },
    //   {
    //     label: "Vendor Management/Vendor Performance Management/Process Flow Chart (Schedule)",
    //     value: "Vendor Management/Vendor Performance Management/Process Flow Chart (Schedule)",
    //     // value: "vendorManagement_vendorPerformanceManagement_vendorPerformanceManagementProcessFlowChartSchedule",
    //   },
    //   {
    //     label: "Vendor Management/Vendor Performance Management/Process Flow Chart (Schedule)/List Process Flow Chart",
    //     value: "Vendor Management/Vendor Performance Management/Process Flow Chart (Schedule)/List Process Flow Chart",
    //     // value: "vendorManagement_vendorPerformanceManagement_vendorPerformanceManagementProcessFlowChartSchedule_vendorManagementProcessFlowChart",
    //   },
    // ];
    // } else if(value === 'FAQ'){
    //   return [];
    // } else if(value==='POPUP'){
    //   return [
    //     {
    //       label: "Camera Access",
    //       value: "cameraAccess",
    //     },
    //     {
    //       label: "Language",
    //       value: "languagePopUp",
    //     },
    //     {
    //       label: "Login",
    //       value: "loginPopUp",
    //     },
    //     {
    //       label: "Logout",
    //       value: "logoutPopUp",
    //     },
    //     {
    //       label: "VMS",
    //       value: "VMSPopUp",
    //     },
    //     {
    //       label: "Purchase Login",
    //       value: "purchaseLoginPopUp",
    //     },
    //     {
    //       label: "Welcome Banner",
    //       value: "welcomeBanner",
    //     }
    //   ]
    // } else if(value ==='LOGIN'){
    //   return [
    //     {
    //       label: "Login Page",
    //       value: "loginPage",
    //     },
    //     {
    //       label: "Mobile Login Page",
    //       value: "mobileLoginPage",
    //     },
    //   ]
    // } else if(value ==='PROFILE'){
    //   return [
    //     {
    //       label: "User Profile Settings",
    //       value: "userProfileSettings",
    //     },
    //     {
    //       label: "Purchase QR",
    //       value: "purchaseQR",
    //     },
    //     {
    //       label: "Purchase Success",
    //       value: "purchaseSuccess",
    //     },
    //   ]
    // } else if(value ==='OTHERS'){
    //   return [
    //     {
    //       label: "Welcome Page For Calendar",
    //       value: "welcomePageForCalendar",
    //     },
    //     {
    //       label: "Calendar Legends",
    //       value: "calendarLegends",
    //     },
    //     {
    //       label: "Banners",
    //       value: "banners",
    //     },
    //   ]
    // } else if(value ==='Gallery'){
    //   return [
    //     {
    //       label: "Gallery List",
    //       value: "galleryList",
    //     },
    //     {
    //       label: "Banner",
    //       value: "banner",
    //     },
    //   ]
    // } else if(value ==='Contact Directory'){
    //   return [
    //     {
    //       label: "CPOs Office",
    //       value: "CposOffice",
    //     },
    //     {
    //       label: "Excellence",
    //       value: "excellence",
    //     },
    //     {
    //       label: "Operation",
    //       value: "operation",
    //     },
    //   ]
    // } 
    if(value === 'Introduction'){ 
      return [
      {
        label: "Preface",
        // value: "introduction_preface",
        value: "Preface",
      },
      {
        label: "Procurement Codes Of Ethics",
        // value: "introduction_procurementCodesOfEthics",
        value: "Procurement Codes Of Ethics",
      },
      {
        label: "General Provision",
        // value: "introduction_generalProvision",
        value: "General Provision",
      },
      {
        label: "Terms & Conditions",
        // value: "introduction_termsAndConditions",
        value: "Terms & Conditions",
      },
      {
        label: "Process Symbols",
        // value: "introduction_processSymbols",
        value: "Process Symbols",
      },
      {
        label: "MAHB Procurement Value Chain",
        // value: "introduction_mahbProcurementValueChain",
        value: "MAHB Procurement Value Chain",
      },
    ];
    } else if(value === 'Procurement Planning'){
      return [
        {
          label: "Business Case/Overview",
          value: "Business Case/Overview",
          // value: "procurementPlanning_businessCase_businessCaseOverview",
        },
        {
          label: "Business Case/Policies",
          value: "Business Case/Policies",
          // value: "procurementPlanning_businessCase_businessCasePolicies",
        },
        {
          label: "Business Case/Process Flow Chart",
          value: "Business Case/Process Flow Chart",
          // value: "procurementPlanning_businessCase_businessCaseProcessFlowChart",
        },
        {
          label: "Business Case/Process Flow Chart/List Process Flow Chart",
          value: "Business Case/Process Flow Chart/List Process Flow Chart",
          // value: "procurementPlanning_businessCase_businessCaseProcessFlowChart_procurementPlanningProcessFlowChart",
        },
        {
          label: "Annual Procurement Planning/Overview",
          value: "Annual Procurement Planning/Overview",
          // value: "procurementPlanning_annualProcurementPlanning_annualProcurementPlanningOverview",
        },
        {
          label: "Annual Procurement Planning/Policies",
          value: "Annual Procurement Planning/Policies",
          // value: "procurementPlanning_annualProcurementPlanning_annualProcurementPlanningPolicies",
        },
        {
          label: "Annual Procurement Planning/Process Flow Chart",
          value: "Annual Procurement Planning/Process Flow Chart",
          // value: "procurementPlanning_annualProcurementPlanning_annualProcurementPlanningProcessFlowChart",
        },
        {
          label: "Annual Procurement Planning/Process Flow Chart/List Process Flow Chart",
          value: "Annual Procurement Planning/Process Flow Chart/List Process Flow Chart",
          // value: "procurementPlanning_annualProcurementPlanning_annualProcurementPlanningProcessFlowChart_procurementPlanningProcessFlowChart",
        },
        {
          label: "Strategy Paper/Overview",
          value: "Strategy Paper/Overview",
          // value: "procurementPlanning_strategyPaper_strategyPaperOverview",
        },
        {
          label: "Strategy Paper/Policies",
          value: "Strategy Paper/Policies",
          // value: "procurementPlanning_strategyPaper_strategyPaperPolicies",
        },
        {
          label: "Strategy Paper/Process Flow Chart",
          value: "Strategy Paper/Process Flow Chart",
          // value: "procurementPlanning_strategyPaper_strategyPaperProcessFlowChart",
        },
        {
          label: "Strategy Paper/Process Flow Chart/List Process Flow Chart",
          value: "Strategy Paper/Process Flow Chart/List Process Flow Chart",
          // value: "procurementPlanning_strategyPaper_strategyPaperProcessFlowChart_procurementPlanningProcessFlowChart",
        },
      ]
    } else if(value === 'Requisition'){
      return [
        {
          label: "Purchase Requisition/Overview",
          value: "Purchase Requisition/Overview",
          // value: "requisition_purchaseRequisition_purchaseRequisitionOverview",
        },
        {
          label: "Purchase Requisition/Policies",
          value: "Purchase Requisition/Policies",
          // value: "requisition_purchaseRequisition_purchaseRequisitionPolicies",
        },
        {
          label: "Purchase Requisition/Process Flow Chart",
          value: "Purchase Requisition/Process Flow Chart",
          // value: "requisition_purchaseRequisition_purchaseRequisitionProcessFlowChart",
        },
        {
          label: "Purchase Requisition/Process Flow Chart/List Process Flow Chart",
          value: "Purchase Requisition/Process Flow Chart/List Process Flow Chart",
          // value: "requisition_purchaseRequisition_purchaseRequisitionProcessFlowChart_requisitionProcessFlowChart",
        },
        {
          label: "Processing of Purchase Requisition/Overview",
          value: "Processing of Purchase Requisition/Overview",
          // value: "requisition_processingofPurchaseRequisition_processingofPurchaseRequisitionOverview",
        },
        {
          label: "Processing of Purchase Requisition/Policies",
          value: "Processing of Purchase Requisition/Policies",
          // value: "requisition_processingofPurchaseRequisition_processingofPurchaseRequisitionPolicies",
        },
        {
          label: "Processing of Purchase Requisition/Process Flow Chart",
          value: "Processing of Purchase Requisition/Process Flow Chart",
          // value: "requisition_processingofPurchaseRequisition_processingofPurchaseRequisitionProcessFlowChart",
        },
        {
          label: "Processing of Purchase Requisition/Process Flow Chart/List Process Flow Chart",
          value: "Processing of Purchase Requisition/Process Flow Chart/List Process Flow Chart",
          // value: "requisition_processingofPurchaseRequisition_processingofPurchaseRequisitionProcessFlowChart_requisitionProcessFlowChart",
        },
      ]
    } else if(value ==='Sourcing'){
      return [
        {
          label: "Tender Management/Overview",
          value: "Tender Management/Overview",
          // value: "sourcing_tenderManagement_tenderManagementOverview",
        },
        {
          label: "Tender Management/Policies",
          value: "Tender Management/Policies",
          // value: "sourcing_tenderManagement_tenderManagementPolicies",
        },
        {
          label: "Tender Management/Process Flow Chart",
          value: "Tender Management/Process Flow Chart",
          // value: "sourcing_tenderManagement_tenderManagementProcessFlowChart",
        },
        {
          label: "Tender Management/Process Flow Chart/List Process Flow Chart",
          value: "Tender Management/Process Flow Chart/List Process Flow Chart",
          // value: "sourcing_tenderManagement_tenderManagementProcessFlowChart_sourcingProcessFlowChart",
        },
        {
          label: "Tender Administration/Overview",
          value: "Tender Administration/Overview",
          // value: "sourcing_tenderAdministration_tenderAdministrationOverview",
        },
        {
          label: "Tender Administration/Policies",
          value: "Tender Administration/Policies",
          // value: "sourcing_tenderAdministration_tenderAdministrationPolicies",
        },
        {
          label: "Tender Administration/Process Flow Chart - above RM50,000.00",
          value: "Tender Administration/Process Flow Chart - above RM50,000.00",
          // value: "sourcing_tenderAdministration_tenderAdministrationProcessFlowChartaboveRM5000000",
        },
        {
          label: "Tender Administration/Process Flow Chart - above RM50,000.00/List Process Flow Chart",
          value: "Tender Administration/Process Flow Chart - above RM50,000.00/List Process Flow Chart",
          // value: "sourcing_tenderAdministration_tenderAdministrationProcessFlowChartaboveRM5000000_sourcingProcessFlowChart",
        },
        {
          label: "Tender Administration/Process Flow Chart - below RM50,000.00",
          value: "Tender Administration/Process Flow Chart - below RM50,000.00",
          // value: "sourcing_tenderAdministration_tenderAdministrationProcessFlowChartbelowRM5000000",
        },
        {
          label: "Tender Administration/Process Flow Chart - below RM50,000.00/List Process Flow Chart",
          value: "Tender Administration/Process Flow Chart - below RM50,000.00/List Process Flow Chart",
          // value: "sourcing_tenderAdministration_tenderAdministrationProcessFlowChartbelowRM5000000_sourcingProcessFlowChart",
        },
        {
          label: "Tender Evaluation/Overview",
          value: "Tender Evaluation/Overview",
          // value: "sourcing_tenderEvaluation_tenderEvaluationOverview",
        },
        {
          label: "Tender Evaluation/Policies",
          value: "Tender Evaluation/Policies",
          // value: "sourcing_tenderEvaluation_tenderEvaluationPolicies",
        },
        {
          label: "Tender Evaluation/Process Flow Chart",
          value: "Tender Evaluation/Process Flow Chart",
          // value: "sourcing_tenderEvaluation_tenderEvaluationProcessFlowChart",
        },
        {
          label: "Tender Evaluation/Process Flow Chart/List Process Flow Chart",
          value: "Tender Evaluation/Process Flow Chart/List Process Flow Chart",
          // value: "sourcing_tenderEvaluation_tenderEvaluationProcessFlowChart_sourcingProcessFlowChart",
        },
        {
          label: "Abort of Tender/Overview",
          value: "Abort of Tender/Overview",
          // value: "sourcing_abortofTender_abortofTenderOverview",
        },
        {
          label: "Abort of Tender/Policies",
          value: "Abort of Tender/Policies",
          // value: "sourcing_abortofTender_abortofTenderPolicies",
        },
        {
          label: "Abort of Tender/Process Flow Chart",
          value: "Abort of Tender/Process Flow Chart",
          // value: "sourcing_abortofTender_abortofTenderProcessFlowChart",
        },
        {
          label: "Abort of Tender/Process Flow Chart/List Process Flow Chart",
          value: "Abort of Tender/Process Flow Chart/List Process Flow Chart",
          // value: "sourcing_abortofTender_abortofTenderProcessFlowChart_sourcingProcessFlowChart",
        },
        {
          label: "Clarification / Negotiation prior to Award/Overview",
          value: "Clarification / Negotiation prior to Award/Overview",
          // value: "sourcing_clarificationNegotiationpriortoAward_clarificationNegotiationpriortoAwardOverview",
        },
        {
          label: "Clarification / Negotiation prior to Award/Policies",
          value: "Clarification / Negotiation prior to Award/Policies",
          // value: "sourcing_clarificationNegotiationpriortoAward_clarificationNegotiationpriortoAwardPolicies",
        },
        {
          label: "Clarification / Negotiation prior to Award/Process Flow Chart Negotiation",
          value: "Clarification / Negotiation prior to Award/Process Flow Chart Negotiation",
          // value: "sourcing_clarificationNegotiationpriortoAward_clarificationNegotiationpriortoAwardProcessFlowChartNegotiation",
        },
        {
          label: "Clarification / Negotiation prior to Award/Process Flow Chart Negotiation/List Process Flow Chart",
          value: "Clarification / Negotiation prior to Award/Process Flow Chart Negotiation/List Process Flow Chart",
          // value: "sourcing_clarificationNegotiationpriortoAward_clarificationNegotiationpriortoAwardProcessFlowChartNegotiation_sourcingProcessFlowChart",
        },
        {
          label: "Clarification / Negotiation prior to Award/Process Flow Chart Clarification Prior to Award",
          value: "Clarification / Negotiation prior to Award/Process Flow Chart Clarification Prior to Award",
          // value: "sourcing_clarificationNegotiationpriortoAward_clarificationNegotiationpriortoAwardProcessFlowChartClarificationPriortoAward",
        },
        {
          label: "Clarification / Negotiation prior to Award/Process Flow Chart Clarification Prior to Award/List Process Flow Chart",
          value: "Clarification / Negotiation prior to Award/Process Flow Chart Clarification Prior to Award/List Process Flow Chart",
          // value: "sourcing_clarificationNegotiationpriortoAward_clarificationNegotiationpriortoAwardProcessFlowChartClarificationPriortoAward_sourcingProcessFlowChart",
        },
      ]
    } else if(value ==='Contract Administration'){
      return [
        {
          label: "Contract Management Implementation/Overview",
          value: "Contract Management Implementation/Overview",
          // value: "contractAdministration_contractManagementImplementation_contractManagementImplementationOverview",
        },
        {
          label: "Contract Management Implementation/Policies",
          value: "Contract Management Implementation/Policies",
          // value: "contractAdministration_contractManagementImplementation_contractManagementImplementationPolicies",
        },
        {
          label: "Contract Management Implementation/Process Flow Chart",
          value: "Contract Management Implementation/Process Flow Chart",
          // value: "contractAdministration_contractManagementImplementation_contractManagementImplementationProcessFlowChart",
        },
        {
          label: "Contract Management Implementation/Process Flow Chart/List Process Flow Chart",
          value: "Contract Management Implementation/Process Flow Chart/List Process Flow Chart",
          // value: "contractAdministration_contractManagementImplementation_contractManagementImplementationProcessFlowChart_contractAdministrationProcessFlowChart",
        },
        {
          label: "Contract Renewal/Overview",
          value: "Contract Renewal/Overview",
          // value: "contractAdministration_contractRenewal_contractRenewalOverview",
        },
        {
          label: "Contract Renewal/Policies",
          value: "Contract Renewal/Policies",
          // value: "contractAdministration_contractRenewal_contractRenewalPolicies",
        },
        {
          label: "Contract Renewal/Process Flow Chart",        
          value: "Contract Renewal/Process Flow Chart",
          // value: "contractAdministration_contractRenewal_contractRenewalProcessFlowChart",
        },
        {
          label: "Contract Renewal/Process Flow Chart/List Process Flow Chart",
          value: "Contract Renewal/Process Flow Chart/List Process Flow Chart",
          // value: "contractAdministration_contractRenewal_contractRenewalProcessFlowChart_contractAdministrationProcessFlowChart",
        },
        {
          label: "Contract Termination/Overview",
          value: "Contract Termination/Overview",
          // value: "contractAdministration_contractTermination_contractTerminationOverview",
        },
        {
          label: "Contract Termination/Policies",
          value: "Contract Termination/Policies",
          // value: "contractAdministration_contractTermination_contractTerminationPolicies",
        },
        {
          label: "Contract Termination/Process Flow Chart",
          value: "Contract Termination/Process Flow Chart",
          // value: "contractAdministration_contractTermination_contractTerminationProcessFlowChart",
        },
        {
          label: "Contract Termination/Process Flow Chart/List Process Flow Chart",
          value: "Contract Termination/Process Flow Chart/List Process Flow Chart",
          // value: "contractAdministration_contractTermination_contractTerminationProcessFlowChart_contractAdministrationProcessFlowChart",
        },
        {
          label: "Contract Closeout/Overview",
          value: "Contract Closeout/Overview",
          // value: "contractAdministration_contractCloseout_contractCloseoutOverview",
        },
        {
          label: "Contract Closeout/Policies",
          value: "Contract Closeout/Policies",
          // value: "contractAdministration_contractCloseout_contractCloseoutPolicies",
        },
        {
          label: "Contract Closeout/Process Flow Chart",
          value: "Contract Closeout/Process Flow Chart",
          // value: "contractAdministration_contractCloseout_contractCloseoutProcessFlowChart",
        },
        {
          label: "Contract Closeout/Process Flow Chart/List Process Flow Chart",
          value: "Contract Closeout/Process Flow Chart/List Process Flow Chart",
          // value: "contractAdministration_contractCloseout_contractCloseoutProcessFlowChart_contractAdministrationProcessFlowChart",
        },
      ]
    } else if(value ==='Vendor Management'){
      return [
        {
          label: "Vendor Registration/Overview",
          value: "Vendor Registration/Overview",
          // value: "vendorManagement_vendorRegistration_vendorRegistrationOverview",
        },
        {
          label: "Vendor Registration/Policies",
          value: "Vendor Registration/Policies",
          // value: "vendorManagement_vendorRegistration_vendorRegistrationPolicies",
        },
        {
          label: "Vendor Registration/Process Flow Chart - Renewal",
          value: "Vendor Registration/Process Flow Chart - Renewal",
          // value: "vendorManagement_vendorRegistration_vendorRegistrationProcessFlowChartRenewal",
        },
        {
          label: "Vendor Registration/Process Flow Chart - Renewal/List Process Flow Chart",
          value: "Vendor Registration/Process Flow Chart - Renewal/List Process Flow Chart",
          // value: "vendorManagement_vendorRegistration_vendorRegistrationProcessFlowChartRenewal_vendorManagementProcessFlowChart",
        },
        {
          label: "Vendor Registration/Process Flow Chart - New Registration",
          value: "Vendor Registration/Process Flow Chart - New Registration",
          // value: "vendorManagement_vendorRegistration_vendorRegistrationProcessFlowChartNewRegistration",
        },
        {
          label: "Vendor Registration/Process Flow Chart - New Registration/List Process Flow Chart",
          value: "Vendor Registration/Process Flow Chart - New Registration/List Process Flow Chart",
          // value: "vendorManagement_vendorRegistration_vendorRegistrationProcessFlowChartNewRegistration_vendorManagementProcessFlowChart",
        },
        {
          label: "Potential Vendor Screening/Overview",
          value: "Potential Vendor Screening/Overview",
          // value: "vendorManagement_potentialVendorScreening_potentialVendorScreeningOverview",
        },
        {
          label: "Potential Vendor Screening/Policies",
          value: "Potential Vendor Screening/Policies",
          // value: "vendorManagement_potentialVendorScreening_potentialVendorScreeningPolicies",
        },
        {
          label: "Potential Vendor Screening/Process Flow Chart",
          value: "Potential Vendor Screening/Process Flow Chart",
          // value: "vendorManagement_potentialVendorScreening_potentialVendorScreeningProcessFlowChart",
        },
        {
          label: "Potential Vendor Screening/Process Flow Chart/List Process Flow Chart",
          value: "Potential Vendor Screening/Process Flow Chart/List Process Flow Chart",
          // value: "vendorManagement_potentialVendorScreening_potentialVendorScreeningProcessFlowChart_vendorManagementProcessFlowChart",
        },
        {
          label: "Vendor Performance Management/Overview",
          value: "Vendor Performance Management/Overview",
          // value: "vendorManagement_vendorPerformanceManagement_vendorPerformanceManagementOverview",
        },
        {
          label: "Vendor Performance Management/Policies",
          value: "Vendor Performance Management/Policies",
          // value: "vendorManagement_vendorPerformanceManagement_vendorPerformanceManagementPolicies",
        },
        {
          label: "Vendor Performance Management/Process Flow Chart (Unscheduled)",
          value: "Vendor Performance Management/Process Flow Chart (Unscheduled)",
          // value: "vendorManagement_vendorPerformanceManagement_vendorPerformanceManagementProcessFlowChartUnscheduled",
        },
        {
          label: "Vendor Performance Management/Process Flow Chart (Unscheduled)/List Process Flow Chart",
          value: "Vendor Performance Management/Process Flow Chart (Unscheduled)/List Process Flow Chart",
          // value: "vendorManagement_vendorPerformanceManagement_vendorPerformanceManagementProcessFlowChartUnscheduled_vendorManagementProcessFlowChart",
        },
        {
          label: "Vendor Performance Management/Process Flow Chart (Schedule)",
          value: "Vendor Performance Management/Process Flow Chart (Schedule)",
          // value: "vendorManagement_vendorPerformanceManagement_vendorPerformanceManagementProcessFlowChartSchedule",
        },
        {
          label: "Vendor Performance Management/Process Flow Chart (Schedule)/List Process Flow Chart",
          value: "Vendor Performance Management/Process Flow Chart (Schedule)/List Process Flow Chart",
          // value: "vendorManagement_vendorPerformanceManagement_vendorPerformanceManagementProcessFlowChartSchedule_vendorManagementProcessFlowChart",
        },
      ]
    }
  } else {
    return [];
  }
};